import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (localStorage.getItem('intrasense-user:session') && localStorage.getItem('intrasense-user:token')) {
      return true;
    } else if(sessionStorage.getItem('intrasense-user:session') && sessionStorage.getItem('intrasense-user:token')) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
